import { defineStore } from 'pinia'

export const useTranslationsStore = defineStore('translations', {
  state: () => ({
    initialized: false,
    loadedLanguages: new Set(),
    currentLanguage: null,
    defaultLanguage: null,
    availableLanguages: [],
    loading: false
  }),

  getters: {
    isInitialized: (state) => state.initialized,
    isLanguageLoaded: (state) => (language) => state.loadedLanguages.has(language),
    getCurrentLanguage: (state) => state.currentLanguage,
    getAvailableLanguages: (state) => state.availableLanguages,
    isLoading: (state) => state.loading
  },

  actions: {
    setInitialized(value) {
      this.initialized = value;
    },

    setCurrentLanguage(language) {
      this.currentLanguage = language;
    },

    setDefaultLanguage(language) {
      this.defaultLanguage = language;
    },

    setAvailableLanguages(languages) {
      this.availableLanguages = languages;
    },

    markLanguageAsLoaded(language) {
      this.loadedLanguages.add(language);
    },

    setLoading(value) {
      this.loading = value;
    },
    reset() {
      this.initialized = false;
      this.loadedLanguages.clear();
      this.currentLanguage = null;
      this.defaultLanguage = null;
      this.availableLanguages = [];
      this.loading = false; // Fixed: was this.isLoading
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTranslationsStore, import.meta.hot))
}
